<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="机构名称:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.schoolName" auto-complete="off" class="formItem" size="small"
					maxLength="200" />
			</el-form-item>
			<el-form-item label="用户名:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.logName" auto-complete="off" class="formItem" size="small" maxLength="100" />
			</el-form-item>
			<el-form-item label="密码:" label-width="110px" prop="password" class="notBlank">
				<el-input v-model="addForm.logPwd" auto-complete="off" class="formItem" size="small" maxLength="50" :disabled="addForm.isEditPwd==0"/>
				<span style="color:#606266;padding-left: 10px" v-if="addForm.id>0"><el-checkbox v-model="addForm.isEditPwd" :true-label="1"
							:false-label="0"></el-checkbox> 修改</span>
			</el-form-item>
			<el-form-item label="教材版本:" label-width="110px" class="notBlank">
					<el-select v-model="addForm.bookVersion" placeholder="请选择" size="small" class="formItem" filterable>
						<el-option v-for="item in bookVersionDict" :key="item.valuekey" :label="item.textkey" :value="item.valuekey">
						</el-option>
					</el-select>
				</el-form-item>
			<el-form-item label="详细地址:" label-width="110px">
				<el-input v-model="addForm.cAddress" auto-complete="off" class="formItem450" size="small"
					maxLength="200" />
			</el-form-item>
			<el-form-item label="负责人:" label-width="110px">
				<el-input v-model="addForm.teamPerson" auto-complete="off" class="formItem" size="small"
					maxLength="100" />
			</el-form-item>
			<el-form-item label="联系电话:" label-width="110px">
				<el-input v-model="addForm.linkTel" auto-complete="off" class="formItem" size="small" maxLength="100" />
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				schoolName: '',
				logName: '',
				logPwd: '',
				cityCode: '',
				cityName: '',
				cAddress: '',
				teamPerson: '',
				linkTel: '',
				status: 1,
				isEditPwd:0,
				bookVersion:'',
			},
			bookVersionDict:[]
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initData() {
			this.$axios.get("/school/getschoolinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if(this.addForm.id>0){
						this.$set(this.addForm,"isEditPwd",0)
						this.addForm.logPwd=''
					}
					else{
						this.$set(this.addForm,"isEditPwd",1)
						this.addForm.status=1
						this.addForm.bookVersion=''
					}
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/school/schoolinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	},
	async created(){
		this.bookVersionDict = (await this.getDictInfo('bookVersion'))
	}
};
</script>

<style lang="less" scoped></style>
